export default __webpack_public_path__ + "static/media/answers-blue.26875ac6.svg";